var render = function render(_c,_vm){return _c('div',{staticClass:"field"},[_vm._t("label"),_vm._v(" "),_c('div',{staticClass:"control"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }